import IUserRepository from "../4_Repositories/IUserRepository";

export default class LogoutUserUseCase {
  private _userRepository: IUserRepository;

  constructor(
    UserRepository: IUserRepository
  ) {
    this._userRepository = UserRepository;
  }

  public execute() {
    this._userRepository.clearAccess();
    this._userRepository.logoutUser();
  }
}
